import Circular from './components/Circular';

export default {
  Circular,
};
